export default {
  path: '/users-settings',
  component: () => import(/* webpackChunkName: "users-settings" */ './UsersSettings'),
  meta: {
    requiresAuth: true,
    pageTitle: 'System Users'
  }
}
